import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { HelpOutline as HelpIcon } from '@mui/icons-material';

import {
  Title,
} from '../../../../../../components/v2/Header';
import { PrimaryButton } from '../../../../../../components/Button/ActionButtons';

import GenerationConfigs from './GenerationConfigs';
import AIPrompt from './AIPrompt';
import ConversationHistory from './ConversationHistory';
import WorkoutGenInstructions from './WorkoutGenInstructions';
import texts from './texts.json';
import { GenerationConfigDefaults } from './constants';
import {
  Container,
  StartOverButton,
  ButtonsContainer,
  StyledTitleContainer,
} from './styles';

const AIWorkoutGenerator = ({
  onGenerate,
  onStartOver,
  currentActivities,
  workoutRequestId,
}) => {
  const [conversationHistory, setConversationHistory] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [generationConfigs, setGenerationConfigs] = useState(GenerationConfigDefaults);

  const handleGenerate = useCallback((activities, latestConversation, requestId) => {
    setConversationHistory([...conversationHistory, ...latestConversation]);
    onGenerate({ activities, workoutRequestId: requestId });
  }, [conversationHistory, onGenerate]);

  const handleStartOver = useCallback(() => {
    setConversationHistory([]);
    setGenerationConfigs(GenerationConfigDefaults);
    onStartOver();
  }, [onStartOver]);

  return (
    <Container>
      <StyledTitleContainer>
        <Title>{texts.title}</Title>
        <ButtonsContainer>
          {!!conversationHistory.length && (
            <StartOverButton
              onClick={handleStartOver}
              variant="light"
              size="small"
            >
              {texts.startOverButton}
            </StartOverButton>
          )}
          <PrimaryButton
            onClick={() => setIsModalOpen(true)}
            variant="warning"
            size="small"
            icon={<HelpIcon />}
          >
            {texts.instructionsButton}
          </PrimaryButton>
        </ButtonsContainer>
      </StyledTitleContainer>
      {!conversationHistory.length ? (
        <GenerationConfigs
          configs={generationConfigs}
          setConfigs={setGenerationConfigs}
        />
      ) : (
        <ConversationHistory conversationHistory={conversationHistory} />
      )}
      <AIPrompt
        onGenerate={handleGenerate}
        conversationHistory={conversationHistory}
        currentActivities={currentActivities}
        workoutRequestId={workoutRequestId}
        generationConfigs={generationConfigs}
      />
      <WorkoutGenInstructions isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Container>
  );
};

AIWorkoutGenerator.propTypes = {
  onGenerate: PropTypes.func.isRequired,
  onStartOver: PropTypes.func.isRequired,
  currentActivities: PropTypes.array.isRequired,
  workoutRequestId: PropTypes.string,
};

AIWorkoutGenerator.defaultProps = {
  workoutRequestId: '',
};

export default AIWorkoutGenerator;
